export default "__VITE_ASSET__e1dc0ff9__"